export default "__VITE_ASSET__Cv33doPd__"